import { render } from "./buy_back_devices.vue?vue&type=template&id=960f5c06"
import script from "./buy_back_devices.vue?vue&type=script&lang=js"
export * from "./buy_back_devices.vue?vue&type=script&lang=js"

import "./buy_back_devices.vue?vue&type=style&index=0&id=960f5c06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__